export default __webpack_public_path__ + "static/media/before-start.b2139f6c.svg";